import { useReducer } from 'react';

import { IProduct, IProductVariant } from '@/interfaces/api/product/IProduct';

export type State = {
	selectedImage: number;
	isProductInHaggle: boolean;
	selectedOptions: Record<string, string>;
	selectedVariant: IProductVariant | null;
	isChatOpen: boolean;
	chatKey: number;
	product: IProduct | null;
	isChatMinimized: boolean;
	isChatInProgress: boolean;
	customReturnAndExchangePolicy?: string;
	shippingPolicy?: string;
};

export type Action =
	| { type: 'SET_PRODUCT'; payload: IProduct }
	| { type: 'SET_IMAGE'; payload: number }
	| { type: 'SET_HAGGLE_STATUS'; payload: boolean }
	| {
			type: 'SET_POLICIES';
			payload: {
				customReturnAndExchangePolicy?: string;
				shippingPolicy?: string;
			};
	  }
	| { type: 'UPDATE_OPTIONS'; payload: Record<string, string> }
	| { type: 'SET_VARIANT'; payload: IProductVariant | null }
	| { type: 'TOGGLE_CHAT'; payload: boolean }
	| { type: 'INCREMENT_CHAT_KEY' }
	| { type: 'TOGGLE_MINIMIZE_CHAT'; payload: boolean }
	| { type: 'TOGGLE_CHAT_PROGRESS'; payload: boolean };

export const initialState: State = {
	selectedImage: 0,
	isProductInHaggle: false,
	selectedOptions: {},
	selectedVariant: null,
	isChatOpen: false,
	chatKey: 0,
	product: null,
	isChatMinimized: false,
	isChatInProgress: false,
	customReturnAndExchangePolicy: undefined,
	shippingPolicy: undefined,
};
export const reducer = (state: State, action: Action): State => {
	switch (action.type) {
		case 'SET_PRODUCT':
			return { ...state, product: action.payload };
		case 'SET_IMAGE':
			return { ...state, selectedImage: action.payload };
		case 'SET_HAGGLE_STATUS':
			return { ...state, isProductInHaggle: action.payload };
		case 'SET_POLICIES':
			return {
				...state,
				customReturnAndExchangePolicy:
					action.payload.customReturnAndExchangePolicy,
				shippingPolicy: action.payload.shippingPolicy,
			};
		case 'UPDATE_OPTIONS':
			return { ...state, selectedOptions: action.payload };
		case 'SET_VARIANT':
			return { ...state, selectedVariant: action.payload };
		case 'TOGGLE_CHAT':
			return { ...state, isChatOpen: action.payload };
		case 'TOGGLE_MINIMIZE_CHAT':
			return { ...state, isChatMinimized: action.payload };
		case 'TOGGLE_CHAT_PROGRESS':
			return { ...state, isChatInProgress: action.payload };
		case 'INCREMENT_CHAT_KEY':
			return { ...state, chatKey: state.chatKey + 1 };
		default:
			return state;
	}
};
export const useHaggleReducer = () => {
	return useReducer(reducer, initialState);
};
